import script from "./SearchSuggests.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchSuggests.vue?vue&type=script&lang=ts&setup=true"

import "./SearchSuggests.vue?vue&type=style&index=0&id=2311ab23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2311ab23"]])

export default __exports__